export interface PublicGuideListItem {
  id: number;
  slug: string;
  guideKind: 'parking' | 'ev';
  titleTh: string;
  titleEn?: string | null;
  summaryTh?: string | null;
  coverImage?: string | null;
  sortOrder: number;
  blockCount: number;
}

export interface PublicGuideBlock {
  id: number;
  sortOrder: number;
  blockType: 'text' | 'image' | 'youtube' | string;
  bodyTh?: string | null;
  bodyEn?: string | null;
  image?: string | null;
  youtubeVideoId?: string | null;
}

export interface PublicGuideDetail {
  id: number;
  slug: string;
  titleTh: string;
  titleEn?: string | null;
  summaryTh?: string | null;
  coverImage?: string | null;
  blocks: PublicGuideBlock[];
}

export function mapPublicGuideListItem(raw: any): PublicGuideListItem {
  const kind = String(raw?.guideKind ?? raw?.GuideKind ?? 'parking').toLowerCase();
  return {
    id: Number(raw?.id ?? raw?.Id ?? 0),
    slug: String(raw?.slug ?? raw?.Slug ?? ''),
    guideKind: kind === 'ev' ? 'ev' : 'parking',
    titleTh: String(raw?.titleTh ?? raw?.TitleTh ?? ''),
    titleEn: raw?.titleEn ?? raw?.TitleEn ?? null,
    summaryTh: raw?.summaryTh ?? raw?.SummaryTh ?? null,
    coverImage: raw?.coverImage ?? raw?.CoverImage ?? null,
    sortOrder: Number(raw?.sortOrder ?? raw?.SortOrder ?? 0),
    blockCount: Number(raw?.blockCount ?? raw?.BlockCount ?? 0),
  };
}

export function mapPublicGuideDetail(raw: any): PublicGuideDetail {
  const blocks = raw?.blocks ?? raw?.Blocks ?? [];
  return {
    id: Number(raw?.id ?? raw?.Id ?? 0),
    slug: String(raw?.slug ?? raw?.Slug ?? ''),
    titleTh: String(raw?.titleTh ?? raw?.TitleTh ?? ''),
    titleEn: raw?.titleEn ?? raw?.TitleEn ?? null,
    summaryTh: raw?.summaryTh ?? raw?.SummaryTh ?? null,
    coverImage: raw?.coverImage ?? raw?.CoverImage ?? null,
    blocks: Array.isArray(blocks)
      ? blocks.map((b: any) => ({
          id: Number(b?.id ?? b?.Id ?? 0),
          sortOrder: Number(b?.sortOrder ?? b?.SortOrder ?? 0),
          blockType: String(b?.blockType ?? b?.BlockType ?? 'text').toLowerCase(),
          bodyTh: b?.bodyTh ?? b?.BodyTh ?? null,
          bodyEn: b?.bodyEn ?? b?.BodyEn ?? null,
          image: b?.image ?? b?.Image ?? null,
          youtubeVideoId: b?.youtubeVideoId ?? b?.YoutubeVideoId ?? null,
        }))
      : [],
  };
}
